/* import __COLOCATED_TEMPLATE__ from './voltage-range.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import VoltageRange from '../../models/results/sub-results/voltage-range';
import type SiteService from '@ebiz/ember-aditools-site/services/aditools-site';

interface VoltageRangeFigureArgs {
  model: VoltageRange;
}

export default class VoltageRangeFigure extends Component<VoltageRangeFigureArgs> {
  @service('aditools-site') declare siteconfig: SiteService;

  get isTolerance(): boolean {
    return !!this.args.model.toleranceInput;
  }
}
